<template lang="pug">
v-simple-table.mb-2(v-if="showIndicator" :id="'virtual-scroll-indicator'+key")
    tbody
        tr
            td.text-center(colspan='100%' style="padding: 12px 16px; background-color: #f5f5f5; border-top: 1px solid #e0e0e0;")
                v-row(justify="center" align="center" no-gutters)
                    v-col(cols="auto")
                        v-chip(color="info" text-color="white" small)
                            v-icon(small left) mdi-arrow-down
                            | Showing {{ visibleCount }} of {{ totalCount }} rows - Scroll down for more
                    v-col(cols="auto" style="margin-left: 12px;")
                        v-btn(color="primary" small outlined @click="handleShowAll")
                            | Show All Rows

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        computed: {
            key() {
                return this.idKey || '';
            },
            showIndicator() {
                return this.visibleCount < this.totalCount;
            },
        },
        props: {
            handleShowAll: Function,
            idKey: String,
            totalCount: Number,
            visibleCount: Number,
        },
    });
</script>

<style lang="scss" scoped>
</style>
